import React from 'react'
import { Layer, Image as ImageKonva } from 'react-konva'

interface WatermarkLayerProps {
    watermarkLayerRef: HTMLImageElement | null
    isVisible: boolean
    width: number
    height: number
}

/**
 * ウォーターマークレイヤー
 * 編集画面のチェックボックス設定に応じて表示/非表示を切り替え
 * レイヤーインデックスを保持するため、常にLayerを返す
 */
export const WatermarkLayer: React.FC<WatermarkLayerProps> = ({ watermarkLayerRef, isVisible, width, height }) => {
    return (
        <Layer visible={isVisible && !!watermarkLayerRef}>
            {watermarkLayerRef && (
                <ImageKonva image={watermarkLayerRef} width={width} height={height} />
            )}
        </Layer>
    )
}
